module.exports = "../images/icons/minus-icon.svg";